<template>
    <div class="h-100 justify-content-center align-items-center">
        <div id="content">
            <AuthBase :title="header.title" :subtitle="header.subtitle">
                <component :is="loadedComponent" @code_required="changeComponent" @2fa_error="changeTwoFAError"/>
            </AuthBase>
        </div>
    </div>
</template>
<script setup>
import AuthBase from "@/components/includes/auth/AuthBase.vue";
import TheLogin from "@/components/includes/auth/login/TheLogin.vue";
import TheLoginCode from "@/components/includes/auth/login/TheLoginCode.vue";
import { ref, shallowRef } from "vue";

const header = ref({
    title: "Seja bem vindo",
    subtitle: "Digite seus dados para entrar.",
});

const loadedComponent = shallowRef(TheLogin);

function changeComponent() {
    header.value = {
        title: "Código de verificação",
        subtitle: "Digite o código que enviamos para seu e-mail.",
    };
    loadedComponent.value = TheLoginCode;
}

function changeTwoFAError(){
    header.value = {
        title: "Seja bem vindo",
        subtitle: "Digite seus dados para entrar.",
    }
    loadedComponent.value = TheLogin;
}

</script>

<style scoped>
#content {
    height: 100%;
}

@media screen and (max-width: 1100px){
    #content {
        width: 100%;
        padding-left: 15px;
        padding-right: 15px;
        background-color: #f7f7f7;
    }

    #background {
        display: none;
    }
}
</style>